// const ENV = "dev";//本地开发
// const ENV = "devServer";//测试机开发
// const ENV = "watch";//测试机开发
// const ENV = "test1";//测试机开发
//  const ENV = "test";//测试4000端口
// const ENV = "demo";//
const ENV = "production";//正式
// const ENV ="23test";
module.exports = ENV;



// WEBPACK FOOTER //
// ./config/env.js